import React, { useEffect, useRef, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import SnippetCard from '../components/main/SnippetMenu';

import { auth } from "../auth/firebase/Firebase";
import { getSnippetList } from "../auth/firebase/snippets/Controller";

import { Search } from "react-bootstrap-icons";
import "../assets/css/SnippetCard.css";

function SnippetList() {
  const searchInput = useRef();

  const [user] = useAuthState(auth);
  const [language, setLanguage] = useState("");

  const [snippets, setSnippets] = useState("");
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (!snippets && snippets.length === 0) {
      getSnippetList()
        .then((list) => {
          setSnippets(list);
        })
    }
  }, [snippets]);


  const cardSection = () => {
    const updateSearch = (lang) => {
      if (searchInput.current.value === "") {
        getSnippetList()
          .then((list) => {
            if (lang !== "") {
              let filteredSnippets = list.filter((s) => {
                return s.language === lang
              });
              setSnippets(filteredSnippets);
            } else {
              setSnippets(list);
            }
          })
      } else {
        getSnippetList(searchInput.current.value)
          .then((list) => {
            if (lang !== "") {
              let filteredSnippets = list.filter((s) => {
                return s.language === lang
              });
              setSnippets(filteredSnippets);
            } else {
              setSnippets(list);
            }
          })
      }
    }

    const resetSearch = () => {
      setSearch("");
      getSnippetList()
        .then((list) => {
          if (language !== "") {
            let filteredSnippets = list.filter((s) => {
              return s.language === language
            });
            setSnippets(filteredSnippets);
          } else {
            setSnippets(list);
          }
        })
    }

    const changeLanguage = (l) => {
      setLanguage(l);
      updateSearch(l);
    }

    return (
      <>
        <div className="container px-4 py-5 snippet-cards">
          <div className="row">
            <h2 className="pb-2 border-bottom">Code Snippets</h2>
            <div className="row py-3">
              <div className="col-md-12">
                <div className="btn-group">
                  <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Language {language ? `(${language})` : ""}
                  </button>
                  <ul className="dropdown-menu">
                    <li><button className="dropdown-item" onClick={() => changeLanguage("Javascript") }>Javascript</button></li>
                    <li><button className="dropdown-item" onClick={() => changeLanguage("Typescript") }>Typescript</button></li>
                    <li><button className="dropdown-item" onClick={() => changeLanguage("HTML") }>HTML</button></li>
                    <li><button className="dropdown-item" onClick={() => changeLanguage("C##") }>C##</button></li>
                    <li><button className="dropdown-item" onClick={() => changeLanguage("C+") }>C+</button></li>
                    <li><button className="dropdown-item" onClick={() => changeLanguage("Python")}>Python</button></li>
                    <li><hr /></li>
                    <li><button className="dropdown-item" onClick={() => setLanguage("")}>Clear</button></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row pb-3">
              <div className="col-md-11">
                <input type="text" className="form-control" id="snippet-title" value={search} ref={searchInput} onChange={event => setSearch(event.target.value)} placeholder="Search ..." />
              </div>
              <div className="col-md-1">
                <div className="btn-group w-100" role="group" aria-label="SearchButtons">
                  <button type="submit" className="btn btn-primary w-100" onClick={() => updateSearch(language)}><Search /></button>
                  <button type="submit" className="btn btn-danger w-100" onClick={() => resetSearch()}>Clear</button>
                </div>
              </div>
            </div>
            {
              snippets && snippets.length > 0 ? (
                snippets.map((snippet, index) => {
                  var descSubstring = snippet.description.substring(0, 300);
                  var lastDot = descSubstring.lastIndexOf('.')
                  lastDot <= 0 ? ( lastDot = descSubstring.length ) : void 0;
                  
                  return (
                  <button className="col-md-4 align-items-stretch g-4 pt-3 default-link" key={index} onClick={() => navigate("/snippet/" + snippet.id)}>

                    <div className="card list-card-item">
                      <div className="card-body">
                        <h5 className="card-title">{snippet.title}</h5>
                        <p className="card-text">{descSubstring.substring(0, lastDot)}</p>
                      </div>
                      <div className="card-footer">
                        <p><b>Language:</b> {snippet.language}</p>
                        <ul className="d-flex list-unstyled mt-auto">
                          {
                            snippet.tags && snippet.tags.length > 0 ? (
                              snippet.tags.map((tag, tindex) => {
                                return (
                                  <li className="d-flex align-items-center" key={index + "-" + tindex}>
                                    <span className="badge text-bg-info tag-spacing">{tag}</span>
                                  </li>
                                )
                              })
                            ) : ("")
                          }
                        </ul>
                      </div>
                    </div>
                  </button>
                  )
                }
                )
              ) : ("")
            }
          </div>
        </div>
      </>
    );
  }


  return (
    <>
      {cardSection()}
      <SnippetCard user={user} />
    </>
  );
}
export default SnippetList;


